module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("a7Beg"))).then(() => parcelRequire('2KbAe'));